import React, { useState } from "react";
import AppButton from "../../components/AppButton";

import Header from "./components/Header";
import Modal from "../../components/Modal";
import Card from "./components/Card";

import glossyImag from "../../assets/images/SuperToroid-2-Blue-Glossy.png";
import created from "../../assets/images/created.png";
import design from "../../assets/images/design.png";
import product from "../../assets/images/product.png";
import social from "../../assets/images/social.png";
import wellness from "../../assets/images/wellness.png";

import "./universe.styles.css";
import Textarea from "../../components/Textarea";
import TextInput from "../../components/TextInput";
import EmptyState from "./components/EmptyState";

const tagImages = { wellness, created, design, product, social };

const Universe = () => {
  const [tags] = useState([
    "social & Fun workshops",
    "design workshops",
    "product workshops",
    "wellness workshops",
    "created by you",
  ]);

  const [activeTag, setActive] = useState(tags[0]);
  const [courseModal, setCourseModal] = useState(false);
  const [workshopModal, setWorkshopModal] = useState(false);
  const [isModuleVisible, setModuleVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");

  // const [courseData, setCourseData] = useState([
  //   {
  //     id: "",
  //     name: "",
  //     description: "",
  //     module: [
  //       {
  //         module_id: "",
  //         name: "",
  //         description: "",
  //         pages: [
  //           {
  //             page_id: "",
  //             name: "",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // ]);

  const onToggleModal = (course) => {
    setModalTitle(course);
    if (course === "Create interactive workshop") {
      setWorkshopModal(!workshopModal);
    } else if (course === "Create interactive course") {
      setCourseModal(!courseModal);
    }
  };

  const onToggleModule = () => {
    setModalTitle("Create a new module");
    setModuleVisible(!isModuleVisible);
  };

  return (
    <section className="universe__wrapper">
      <section className="dashboard__container universe__style">
        <Header onToggleModal={onToggleModal} />
        <section className="universe__masthead d-flex">
          <section className="universe__masthead--left pl-40 pt-40">
            <div className="teacher--card d-flex">
              <span className="teacher--cardTag">M</span>
              <div className="teacher--cardDetails">
                <h6 className="font--medium">Maya James</h6>
                <p className="font--regular">Product designer at klen</p>
              </div>
            </div>
            <div className="universe__masthead--content">
              <h1 className="font--medium">Team work makes the dream work</h1>
              <p className="font--regular">
                The payments landscape has gone through significant
                transformation in recent years. Technological advancements have
                led to step changes in innovation, with payments becoming
                faster, on both a local and global scale, easier and more
                convenient. This has not gone unnoticed by the regulators who
                are now looking into how regulation needs to adapt to meet these
                changes. As business and customer needs evolve
              </p>
            </div>
            <AppButton
              type="main"
              title="Start playing"
              styles={{
                backgroundColor: "#2E0254",
                boxShadow: " 0px 2px 3px rgba(0, 0, 0, 0.05)",
              }}
            />
          </section>
          <div className="pl-40 img--section">
            <img src={glossyImag} alt="" />
            <section className="circle"></section>
          </div>
          <span className="klen--tag positioning">virtually interactive</span>
        
        </section>
      </section>
      <section className="course__tags">
        <div className="dashboard__container d-flex flex-row">
          {tags.map((tag) => {
            return (
              <div
                className={activeTag === tag ? "tags is--active" : "tags"}
                onClick={() => setActive(tag)}
              >
                {renderIcon(tag)}
                {tag}
              </div>
            );
          })}
        </div>
      </section>
      <div className="dashboard__container">
        <main className="universe__workshop mt-24 d-flex justify-content-between">
          <Card />
          <Card />
          <Card />
          <Card />
          {/* <EmptyState /> */}
        </main>
      </div>
      <Modal
        visible={workshopModal}
        title={modalTitle && modalTitle}
        btnTitle="Create workshop"
        onClose={() => onToggleModal("Create interactive workshop")}
      >
        <section className="course__modalContainer">
          <p>
            The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum
            dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magn
          </p>
          <section className="course__modalBody">
            <div className="">
              <TextInput label="Workshop name" placeholder="Finance course" />
            </div>
            <div className="mt-16">
              <Textarea
                label="Workshop description"
                placeholder="Finance course"
              />
            </div>
          </section>
        </section>
      </Modal>
      <Modal
        visible={courseModal}
        title={modalTitle}
        btnTitle={
          modalTitle === "Create interactive course" ? "Create course" : "Save"
        }
        onClose={() => onToggleModal("Create interactive course")}
      >
        {modalTitle === "Create a new module" ? (
          <CreateModule />
        ) : (
          <CreateCourse onToggleModule={onToggleModule} />
        )}
      </Modal>
 
    </section>
  );
};

const CreateModule = () => {
  return (
    <section className="course__modalContainer">
      <p>
        The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum
        dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magn
      </p>
      <section className="course__modalBody">
        <div className="">
          <TextInput label="Module name" placeholder="Finance course" />
        </div>
        <div className="mt-16">
          <Textarea label="Module description" placeholder="Finance course" />
        </div>
        <section className="modulePages">
          <h6>Pages</h6>
          <div className="modulePages__list">
            <div className="modulePages__list--item">
              <span className="modulePages__list--draggable">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="6.92017"
                    y="3.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="6.92017"
                    y="9.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="6.92017"
                    y="15.9601"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="12.9202"
                    y="3.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="12.9202"
                    y="9.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="12.9202"
                    y="15.9601"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                </svg>
              </span>
              <input type="text" />
              <span className="modulePages__list--delete">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.75 7.75L7.59115 17.4233C7.68102 18.4568 8.54622 19.25 9.58363 19.25H14.4164C15.4538 19.25 16.319 18.4568 16.4088 17.4233L17.25 7.75"
                    stroke="#2C2B35"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.75 7.5V6.75C9.75 5.64543 10.6454 4.75 11.75 4.75H12.25C13.3546 4.75 14.25 5.64543 14.25 6.75V7.5"
                    stroke="#2C2B35"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 7.75H19"
                    stroke="#2C2B35"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 11V15.5"
                    stroke="#2C2B35"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14 11V15.5"
                    stroke="#2C2B35"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
            </div>
            <div className="modulePages__list--item mt--16">
              <span className="modulePages__list--draggable">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="6.92017"
                    y="3.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="6.92017"
                    y="9.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="6.92017"
                    y="15.9601"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="12.9202"
                    y="3.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="12.9202"
                    y="9.96008"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                  <rect
                    x="12.9202"
                    y="15.9601"
                    width="4"
                    height="4"
                    rx="2"
                    fill="#C3C3C3"
                  />
                </svg>
              </span>
              <input type="text" />
              <span className="modulePages__list--delete">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.75 7.75L7.59115 17.4233C7.68102 18.4568 8.54622 19.25 9.58363 19.25H14.4164C15.4538 19.25 16.319 18.4568 16.4088 17.4233L17.25 7.75"
                    stroke="#2C2B35"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.75 7.5V6.75C9.75 5.64543 10.6454 4.75 11.75 4.75H12.25C13.3546 4.75 14.25 5.64543 14.25 6.75V7.5"
                    stroke="#2C2B35"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 7.75H19"
                    stroke="#2C2B35"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 11V15.5"
                    stroke="#2C2B35"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14 11V15.5"
                    stroke="#2C2B35"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
            </div>
          </div>
        </section>
      </section>
     
    </section>
  );
};

const CreateCourse = ({ onToggleModule }) => {
  return (
    <section className="course__modalContainer">
      <p>
        The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum
        dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magn
      </p>
      <section className="course__modalBody">
        <div className="">
          <TextInput label="Course name" placeholder="Finance course" />
        </div>
        <div className="mt-16">
          <Textarea label="Course description" placeholder="Finance course" />
        </div>

        <div className="mt-16 module__list">
          <section className="modulePages mb--24">
            <h6>Modules</h6>
            <div className="modulePages__list">
              <div className="modulePages__list--item">
                <span className="modulePages__list--draggable">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="6.92017"
                      y="3.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="6.92017"
                      y="9.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="6.92017"
                      y="15.9601"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="12.9202"
                      y="3.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="12.9202"
                      y="9.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="12.9202"
                      y="15.9601"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                  </svg>
                </span>
                <input type="text" />
                <span className="modulePages__list--delete">Edit</span>
              </div>
              <div className="modulePages__list--item mt--16">
                <span className="modulePages__list--draggable">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="6.92017"
                      y="3.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="6.92017"
                      y="9.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="6.92017"
                      y="15.9601"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="12.9202"
                      y="3.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="12.9202"
                      y="9.96008"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                    <rect
                      x="12.9202"
                      y="15.9601"
                      width="4"
                      height="4"
                      rx="2"
                      fill="#C3C3C3"
                    />
                  </svg>
                </span>
                <input type="text" />
                <span className="modulePages__list--delete">Edit</span>
              </div>
            </div>
          </section>
          <button className="add--module" onClick={onToggleModule}>
            Add module
            <span>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99992 0.333313C7.46016 0.333313 7.83325 0.706409 7.83325 1.16665V6.16665H12.8333C13.2935 6.16665 13.6666 6.53975 13.6666 6.99998C13.6666 7.46022 13.2935 7.83332 12.8333 7.83332H7.83325V12.8333C7.83325 13.2936 7.46016 13.6666 6.99992 13.6666C6.53968 13.6666 6.16659 13.2936 6.16659 12.8333V7.83332H1.16659C0.706348 7.83332 0.333252 7.46022 0.333252 6.99998C0.333252 6.53975 0.706348 6.16665 1.16659 6.16665H6.16659V1.16665C6.16659 0.706409 6.53968 0.333313 6.99992 0.333313Z"
                  fill="#2E0254"
                />
              </svg>
            </span>
          </button>
        </div>
      </section>
    </section>
  );
};

const renderIcon = (tag) => {
  const slitted = tag.split(" ");
  return <img src={tagImages[slitted[0]]} alt="" />;
};

export default Universe;
